import API from './base';

class CPFOffersAPI extends API {
  apiBase = '/api/web/v1/cpf_offers_schools';

  getOffersByCoordinates(latitude, longitude, sort_by) {
    const offersQueryParams = new URLSearchParams({
      latitude,
      longitude,
      sort_by,
    });

    return this.get(this.apiBase, offersQueryParams);
  }

  getOffersBySchoolId(schoolId, sort_by) {
    const offersQueryParams = new URLSearchParams({
      schoolId,
      sort_by,
    });

    return this.get(this.apiBase, offersQueryParams);
  }
}

export default new CPFOffersAPI();
